import { useContext } from "react"
import { useTranslation } from "react-i18next"
import Button from "../formfields/Button"
import { GlobalContext } from "../GlobalContext"
import { subscribe } from "../utils/pubsub"


type Props = {
    selectedButtonClass: 'primary' | 'white' | 'secondary' | 'gray'
    unSelectedButtonClass: 'primary' | 'white' | 'secondary' | 'gray'

}


function SwitchLanguage({
    selectedButtonClass,
    unSelectedButtonClass
}: Props) {


    const { i18n } = useTranslation()
    const { userData, sendMessageToWebsocket } = useContext(GlobalContext)

    const selectLanguage = (language: string) => {
        localStorage.setItem('i18nextLng', language)
        i18n.changeLanguage(language)

        // only guest / external users have no cognito id - for them, stick to
        // front-end-only language switching and skip the backend entirely
        if (userData?.email && userData?.['cognito:username'] && sendMessageToWebsocket) {
            console.log(`🌐 Submitting manual language update: ${language}`)

            const unsubscribe = subscribe("updateUserLanguageResponse", (data: any) => {
                console.log('🌐 Received updateUserLanguageResponse', data)
                unsubscribe()
            })

            sendMessageToWebsocket(JSON.stringify({
                action: "user",
                subAction: "updateLanguage",
                email: userData.email,
                language,
                languageSource: "manual"
            }))
        }
    }

    return <div
        className={`flex flex-row gap-1`}>
        <Button
            onClick={() => selectLanguage('en')}
            text={`English`}
            variant={i18n.language === 'en' ? selectedButtonClass : unSelectedButtonClass}
            size={'small'}
        />
        <Button
            onClick={() => selectLanguage('ar')}
            text={`عربي`}
            variant={i18n.language === 'ar' ? selectedButtonClass : unSelectedButtonClass}
            size={'small'}
        />
        <Button
            onClick={() => selectLanguage('es')}
            text={`Español`}
            variant={i18n.language === 'es' ? selectedButtonClass : unSelectedButtonClass}
            size={'small'}
        />
    </div>
}

export default SwitchLanguage